module.exports = __webpack_public_path__ + "img/check-fill-email.41f75c21.svg";